import { useEffect, useState } from "react";
import ContactType from "./contact-type";
import LeadSourcePage from "../lead-source/mainCreateLead";
import { useStateValue } from "../../context/StateProvider";
import MainUserManagement from "../user-managment/main-user";
import MainTaskTemplate from "../task-template/main-template";
import MainLockboxInventory from "../lockbox-inventory/main-lockbox";
import { useLocation } from "react-router-dom";
import gmail from "../../images/gmail.png";
import { toast } from "react-toastify";
import {
  getuserinformation,
  updateUserProfile,
} from "../../utils/firebasefunctions";
import { actionType } from "../../context/reducer";
import moment from "moment";
import EmailLog from "./email-log";
import EmailTemplatesTab from "./email-templates-tab";
import NotificationsTab from "./notifications-tab";
import LabelsTab from "./labels-tab";
import BulkUploadTab from "./bulk-upload-tab";
import TeamDefaultsTab from "./team-defaults-tab";
import { Loader2 } from "lucide-react";
import PageHeader from "../PageHeader";

function MainSettings() {
  const [{ user }, dispatch] = useStateValue();
  console.log("user", user);
  const location = useLocation();
  const queryTab = new URLSearchParams(location.search).get("tab");
  const [isConnecting, setIsConnecting] = useState(false);
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [activeTab, setActiveTab] = useState("gmailConnection");
  const tabs = [
    {
      id: "bulkUpload",
      label: "Bulk Upload Deals",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "labels",
      label: "Contact Labels",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "contactType",
      label: "Contact Type",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "emailLog",
      label: "Email Log",
      allowedUserRole: ["Admin", "Supervisor", "Employee"],
    },
    {
      id: "emailTemplates",
      label: "Email Templates",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "gmailConnection",
      label: "Gmail Connection",
      allowedUserRole: ["Admin", "Supervisor", "Employee"],
    },
    {
      id: "leadSource",
      label: "Lead Source",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "lockboxInventory",
      label: "Lockbox Inventory",
      allowedUserRole: ["Admin", "Supervisor", "Employee"],
    },
    {
      id: "notifications",
      label: "Notifications",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "taskTemplate",
      label: "Task Templates",
      allowedUserRole: ["Admin", "Supervisor", "Employee"],
    },
    {
      id: "teamDefaults",
      label: "Team Defaults",
      allowedUserRole: ["Admin", "Supervisor"],
    },
    {
      id: "userManagment",
      label: "User Managment",
      allowedUserRole: ["Admin", "Supervisor"],
    },
  ].sort((a, b) => a.label.localeCompare(b.label));

  const userRole = user?.role;

  const filteredTabs = tabs.filter(
    (tab) =>
      Array.isArray(tab.allowedUserRole) &&
      tab.allowedUserRole.includes(userRole),
  );

  useEffect(() => {
    if (queryTab && filteredTabs.find((t) => t.id === queryTab)) {
      setActiveTab(queryTab);
    }
  }, [queryTab]);

  useEffect(() => {
    const client = window.google.accounts.oauth2.initCodeClient({
      // const client = window.google.accounts.oauth2.initTokenClient({
      client_id:
        "627842934381-7bra6ha78jub716ceu9hq433chsh69dn.apps.googleusercontent.com",
      scope:
        "https://www.googleapis.com/auth/contacts https://www.googleapis.com/auth/gmail.send openid email profile",
      // "https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/contacts openid email profile ",
      prompt: "consent",
      callback: (response) => {
        if (response.code) {
          console.log("google", response);
          sendtoken(response.code);
        }
      },
    });

    window.loginWithGoogle = () => {
      client.requestCode();
    };
  }, []);

  const sendtoken = async (token) => {
    setIsConnecting(true);
    try {
      const res = await fetch(
        // "http://localhost:3003/getgmailrefreshtoken",
        "https://us-central1-team-edelstein.cloudfunctions.net/api/getgmailrefreshtoken",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code: token,
            id: user.id,
          }),
        },
      );

      if (res.status === 200) {
        console.log("Successfully Retreived Contacts");
        toast.success("Gmail Signed in Successfully!");
        const userInfo = await getuserinformation("users", user.id);
        dispatch({ type: actionType.SET_USER, payload: userInfo });
      } else {
        toast.error("Authentication Error");
      }
    } catch (error) {
      toast.error("Authentication Error");
      console.error("Error:", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const disconnect = async () => {
    setIsDisconnecting(true);
    const updatedProfile = {
      gmailtoken: {},
      gmailuserinfo: {},
      googleContactSync: {},
    };

    console.log("updatedProfile", updatedProfile);

    // Update in Firebase
    await updateUserProfile(user.id, updatedProfile).then(async () => {
      const userInfo = await getuserinformation("users", user.id);

      dispatch({ type: actionType.SET_USER, payload: userInfo });
      toast.success("Gmail Disconnected Successfully!");
      setIsDisconnecting(false);
    });
  };

  const Gmailintegration = () => {
    return (
      <div className="rounded-xl border border-gray-100 bg-white shadow-sm p-6">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
          Email Sending — Gmail
        </h2>

        <div
          className={`rounded-xl border ${user?.gmailtoken?.access_token ? "border-green-500 bg-green-50" : "border-gray-300"} mt-4 p-4 flex flex-row items-center justify-between gap-4`}
        >
          <div className="flex flex-row items-center">
            {user?.gmailuserinfo?.picture ? (
              <img
                src={user?.gmailuserinfo?.picture}
                alt="prop"
                className="w-[50px] h-[50px] object-contain rounded"
              />
            ) : (
              <img
                src={gmail}
                alt="prop"
                className="w-[50px] h-[50px] object-contain rounded"
              />
            )}

            {user?.gmailuserinfo?.email ? (
              <div className="ml-[20px]">
                <p class="text-green-900 text-[12px]">✓ CONNECTED</p>

                <p class="text-black  font-semibold text-[14px]">
                  {user?.gmailuserinfo?.email}
                </p>
                <p class="text-gray-500   text-[12px]">
                  {`Connected ${moment(user?.gmailuserinfo?.syncedAt).format("MMMM DD, YYYY")} · Auto-send and preview-and-send enabled`}
                </p>
              </div>
            ) : (
              <div className="ml-[20px] mr-[20px]">
                <p class="text-gray-500 mt-1 text-[0.95rem]">
                  Connect your Gmail account so TES can send emails (vendor
                  notifications, open house scheduling, seller recaps) directly
                  from your address. Replies go to your inbox just like any
                  other email. You can disconnect at any time.
                </p>
              </div>
            )}
          </div>
          <button
            className={`rounded-xl border border-gray-100 ${user?.gmailtoken?.access_token ? "hover:border-red-500 hover:bg-red-50 hover:text-red-500" : "hover:border-green-500 hover:bg-green-50 hover:text-green-500"}   bg-white shadow  p-2 text-[14px] text-gray-500`}
            onClick={() => {
              if (user?.gmailtoken?.access_token) {
                disconnect();
              } else {
                window.loginWithGoogle();
              }
            }}
          >
            {isConnecting || isDisconnecting ? (
              <span className="flex items-center gap-2">
                <Loader2 className="w-4 h-4 animate-spin" />
                {isConnecting ? "Connecting..." : "Disconnecting..."}
              </span>
            ) : user?.gmailtoken?.access_token ? (
              "Disconnect"
            ) : (
              "Connect"
            )}
          </button>
        </div>
      </div>
    );
  };
  return (
    <div className="h-screen flex flex-col bg-slate-50">
      <PageHeader title="Settings" />

      <div className="flex-1 min-h-0 flex flex-col lg:flex-row overflow-hidden">
        <nav
          className="
            flex-shrink-0
            flex flex-row lg:flex-col gap-1
            overflow-x-auto lg:overflow-x-visible lg:overflow-y-auto
            border-b lg:border-b-0 lg:border-r border-black/10
            bg-white
            px-3 py-2 lg:px-3 lg:py-4
            lg:w-[220px]
          "
        >
          {filteredTabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`
                  group relative text-left whitespace-nowrap
                  text-sm font-medium
                  px-4 py-2.5 rounded-md flex-shrink-0
                  transition-colors
                  ${
                    isActive
                      ? "bg-indigo-50 text-indigo-700"
                      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                  }
                `}
              >
                <span
                  className={`
                    hidden lg:block
                    absolute left-0 top-1/2 -translate-y-1/2
                    w-[3px] rounded-r-md
                    bg-indigo-500
                    transition-all duration-200
                    ${isActive ? "h-[60%]" : "h-0 group-hover:h-[40%]"}
                  `}
                />
                {tab.label}
              </button>
            );
          })}
        </nav>

        <div className="settings-dense flex-1 min-h-0 overflow-y-auto p-3 lg:p-4">
          {activeTab === "contactType" ? (
            <ContactType />
          ) : activeTab === "leadSource" ? (
            <LeadSourcePage />
          ) : activeTab === "userManagment" ? (
            <MainUserManagement />
          ) : activeTab === "taskTemplate" ? (
            <MainTaskTemplate />
          ) : activeTab === "lockboxInventory" ? (
            <MainLockboxInventory />
          ) : activeTab === "gmailConnection" ? (
            <Gmailintegration />
          ) : activeTab === "emailTemplates" ? (
            <EmailTemplatesTab />
          ) : activeTab === "notifications" ? (
            <NotificationsTab />
          ) : activeTab === "labels" ? (
            <LabelsTab />
          ) : activeTab === "bulkUpload" ? (
            <BulkUploadTab />
          ) : activeTab === "teamDefaults" ? (
            <TeamDefaultsTab />
          ) : (
            <EmailLog />
          )}
        </div>
      </div>
    </div>
  );
}

export default MainSettings;
